export default __webpack_public_path__ + "static/media/CV-KLS.08656035.pdf";